function EnrouteStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#FFEDD5] font-OpenSansSemiBold font-[600] text-[#C2410C] text-[14px] leading-[20px] tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
      Enroute
    </div>
  );
}

export default EnrouteStatus;
